import styled from '@xstyled/styled-components'

export type Pixels = `${number}px`

export const avatarSizes = ['2xl', 'xl', 'lg', 'md', 'sm', 'xs', '2xs'] as const

export type AvatarSize = typeof avatarSizes[number]

export function avatarSizeToCircleSize(avatarSize: AvatarSize = 'md'): Pixels {
  const sizeMap: Record<AvatarSize, Pixels> = {
    '2xl': '128px',
    xl: '96px',
    lg: '64px',
    md: '48px',
    sm: '32px',
    xs: '24px',
    '2xs': '16px'
  }
  return sizeMap[avatarSize]
}

export function avatarSizeToBorderSize(avatarSize: AvatarSize = 'md'): Pixels {
  const sizeMap: Record<AvatarSize, Pixels> = {
    '2xl': '4px',
    xl: '3px',
    lg: '3px',
    md: '3px',
    sm: '3px',
    xs: '2px',
    '2xs': '2px'
  }

  return sizeMap[avatarSize]
}

export function getBorderWidth(
  bordered: boolean | number,
  size: AvatarSize = 'md'
): Pixels {
  if (typeof bordered === 'number') {
    return `${bordered}px`
  }

  return avatarSizeToBorderSize(size)
}

export function numericAvatarSizeToCircleSize(
  avatarSize: AvatarSize = 'md'
): number {
  return Number(avatarSizeToCircleSize(avatarSize).replace('px', ''))
}

export interface StyledAvatarProps {
  bordered?: boolean | number
  size?: AvatarSize
}

export const StyledCommonAvatar = styled.spanBox<StyledAvatarProps>(
  {
    textTransform: 'uppercase',
    textAlign: 'center',
    userSelect: 'none',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: '0',
    borderRadius: '50%',
    fontWeight: '500',
    position: 'relative',
    zIndex: '1',
    outline: 'transparent solid 2px !important',
    outlineOffset: '2px',
    color: 'white'
  },
  props => ({
    width: avatarSizeToCircleSize(props.size),
    height: avatarSizeToCircleSize(props.size)
  }),
  props =>
    Boolean(props.bordered) && {
      border: `${getBorderWidth(props.bordered!, props.size)} solid white`
    }
)
